import { render, staticRenderFns } from "./mailing-sort-by.vue?vue&type=template&id=2dac58e8&scoped=true"
import script from "./mailing-sort-by.vue?vue&type=script&lang=js"
export * from "./mailing-sort-by.vue?vue&type=script&lang=js"
import style0 from "./mailing-sort-by.vue?vue&type=style&index=0&id=2dac58e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dac58e8",
  null
  
)

export default component.exports